import EquipmentsUnitsBrandsTable from './brands/table';
import EquipmentsUnitsConditionsTable from './conditions/table';
import EquipmentsUnitsManufacturersTable from './manufacturer/table';
import EquipmentsUnitsStatusesTable from './statuses/table';
import EquipmentsUnitsCheckedStatusesTable from './checkd-statuses/table';

export const tabs = [
  {
    id: 2,
    name: 'Производители ТО',
    component: EquipmentsUnitsManufacturersTable,
  },
  {
    id: 3,
    name: 'Бренды ТО',
    component: EquipmentsUnitsBrandsTable,
  },
  {
    id: 4,
    name: 'Статусы ТО',
    component: EquipmentsUnitsStatusesTable,
  },
  {
    id: 5,
    name: 'Состояние ТО',
    component: EquipmentsUnitsConditionsTable,
  },
  {
    id: 6,
    name: 'Статусы проверки ремонта',
    component: EquipmentsUnitsCheckedStatusesTable,
  },
];
